import axios from 'axios';
import * as endPoints from '../../../../Constants/Endpoints'

export function GetBarbers() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barbers,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function CreateLeave(barberId, startDateTime, endDateTime) {
    const leaveDto = {
        barberId,
        startDateTime,
        endDateTime
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Leave, leaveDto,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function UpdateLeave(leaveId, barberId, startDateTime, endDateTime) {
    const leaveDto = {
        leaveId,
        barberId,
        startDateTime,
        endDateTime
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Leave, leaveDto,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function DeleteLeave(leaveId) {
    return axios.delete(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Leave,
    {
        params: { leaveId },
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetRoster(dateTime) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Roster,
    { 
        params: {dateTime},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}